var map = {
	"./music_recap_yearly/af/index.json": 48010,
	"./music_recap_yearly/am/index.json": 50389,
	"./music_recap_yearly/ar/index.json": 58860,
	"./music_recap_yearly/az/index.json": 15217,
	"./music_recap_yearly/bg/index.json": 65872,
	"./music_recap_yearly/bn/index.json": 77059,
	"./music_recap_yearly/ca/index.json": 92778,
	"./music_recap_yearly/cs/index.json": 61200,
	"./music_recap_yearly/da/index.json": 99412,
	"./music_recap_yearly/de/index.json": 20423,
	"./music_recap_yearly/el/index.json": 59947,
	"./music_recap_yearly/en/index.json": 67329,
	"./music_recap_yearly/es/index.json": 89749,
	"./music_recap_yearly/et/index.json": 57897,
	"./music_recap_yearly/fa/index.json": 70175,
	"./music_recap_yearly/fi/index.json": 69298,
	"./music_recap_yearly/fil/index.json": 22328,
	"./music_recap_yearly/fr/index.json": 57611,
	"./music_recap_yearly/gu/index.json": 62211,
	"./music_recap_yearly/he/index.json": 82835,
	"./music_recap_yearly/hi/index.json": 12989,
	"./music_recap_yearly/hr/index.json": 62769,
	"./music_recap_yearly/hu/index.json": 80431,
	"./music_recap_yearly/in/index.json": 10338,
	"./music_recap_yearly/it/index.json": 34453,
	"./music_recap_yearly/ja/index.json": 47123,
	"./music_recap_yearly/ka/index.json": 80100,
	"./music_recap_yearly/km/index.json": 26265,
	"./music_recap_yearly/kn/index.json": 35957,
	"./music_recap_yearly/ko/index.json": 93412,
	"./music_recap_yearly/lo/index.json": 99990,
	"./music_recap_yearly/lt/index.json": 80179,
	"./music_recap_yearly/lv/index.json": 66027,
	"./music_recap_yearly/ml/index.json": 5622,
	"./music_recap_yearly/mr/index.json": 69288,
	"./music_recap_yearly/ms/index.json": 80893,
	"./music_recap_yearly/my/index.json": 23650,
	"./music_recap_yearly/nl/index.json": 44418,
	"./music_recap_yearly/pa-IN/index.json": 65235,
	"./music_recap_yearly/pa-PK/index.json": 20474,
	"./music_recap_yearly/pl/index.json": 65192,
	"./music_recap_yearly/pt/index.json": 90445,
	"./music_recap_yearly/ro/index.json": 21014,
	"./music_recap_yearly/ru/index.json": 3209,
	"./music_recap_yearly/sk/index.json": 69501,
	"./music_recap_yearly/sl/index.json": 45535,
	"./music_recap_yearly/sr/index.json": 23683,
	"./music_recap_yearly/sv/index.json": 29617,
	"./music_recap_yearly/sw/index.json": 42458,
	"./music_recap_yearly/ta/index.json": 19058,
	"./music_recap_yearly/te/index.json": 75316,
	"./music_recap_yearly/tg/index.json": 59498,
	"./music_recap_yearly/th/index.json": 16738,
	"./music_recap_yearly/tk/index.json": 32712,
	"./music_recap_yearly/tr/index.json": 57533,
	"./music_recap_yearly/uk/index.json": 48242,
	"./music_recap_yearly/ur/index.json": 91102,
	"./music_recap_yearly/uz/index.json": 64376,
	"./music_recap_yearly/vi/index.json": 37626,
	"./music_recap_yearly/zh/index.json": 47989,
	"./music_recap_yearly/zu/index.json": 94636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28137;